import Search from './Search.component';
export default Search;